export default function offerSchemaType (type) {
    return {
        'car_ad': 'Vehicle',
        'truck_ad': 'BusOrCoach',
        'budowlane': 'BusOrCoach',
        'przyczepy': 'BusOrCoach',
        'motorcycle_ad': 'Motorcycle',
        'agri_ad': 'Vehicle',
        'part_ad': 'Product',
        'tool_ad': 'Product',
        'service_ad': 'Service'
    }[type] || 'Vehicle'
}